export const INVENTORY_CONFIGURATION = "inventory-configuration" as const
export const INVENTORY_LOCATION = "inventory-location" as const
export const INVENTORY_STOCK_DOCUMENT_DEFINITION = "inventory-stock-document-definition" as const
export const INVENTORY_STOCK_DOCUMENT = "inventory-stock-document" as const
export const STOCK_DOCUMENT = "stock-document" as const
export const STOCK_DOCUMENTS = "stock-documents" as const
export const STOCK_DOCUMENT_LINES = "stock-document-lines" as const
export const INVENTORY_RESERVATION = "inventory-reservation" as const
export const INVENTORY_IN_TRANSIT = "inventory-in-transit" as const

export namespace INVENTORY_STOCK_DIRECTION {
    export const IN = "IN" as const
    export const OUT = "OUT" as const
    export const IN_OUT = "IN_OUT" as const
}

export type InventoryStockDirection = typeof INVENTORY_STOCK_DIRECTION[keyof typeof INVENTORY_STOCK_DIRECTION]



// WEBPACK FOOTER //
// ./src/utils/inventory/constants.ts